import baseUrl from "../config/baseUrl";

const getActiveEmailTemplates = async ({ token }) => {
  try {
    const response = await fetch(`${baseUrl}/api/get-active-email-templates`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default getActiveEmailTemplates;
